import { useContent } from '@gemini-vsf/composables';
import { contentGetters } from '~/composables';

const getCodesFromAttribute = (product, attribute) => (product && product[attribute] ? product[attribute].replaceAll(' ', '').split(',') : []);

const getDataFromCodes = (content, codes) => {
  const data = [];
  codes.forEach((code) => {
    const trimmedCode = code?.trim();
    if (trimmedCode && content[trimmedCode] && content[trimmedCode].active) {
      data.push(content[trimmedCode]);
    }
  });
  return data.length > 0 ? data : null;
};

const managePairedMediaData = (pairedMediaData) =>
  pairedMediaData?.length > 0
    ? pairedMediaData.map((m) =>
        m?.active && m.data?.length > 0 ? m.data.filter((e) => (e.mediaType === 'image' ? e.image : e.videoDesktop || e.videoMobile)) : []
      )
    : [];

const productBlocks = () => {
  const { blocks, loadBlocks } = useContent('pdp-blocks');

  const getPdpBlocks = async (product, localeValue) => {
    const handcraftedSelector = `hp-handcrafted-${localeValue}`;
    const faqSelector = `pdp-faq-${localeValue}`;
    const customisedGlassLightingSelector = `pdp-customised-glass-lighting-${localeValue}`;
    const featuresCodes = getCodesFromAttribute(product, 'features');
    const featuresSelector = `pdp-features-${localeValue}`;
    const pairedMediaCodes = getCodesFromAttribute(product, 'video_pdp');
    const pairedMediaSelector = `pdp-paired-media-${localeValue}`;
    const designersCodes = getCodesFromAttribute(product, 'maestro_vetraio');
    const designersSectionSelector = `pdp-designers-${localeValue}`;

    const identifiersToLoad = [handcraftedSelector, faqSelector, customisedGlassLightingSelector];
    if (featuresCodes?.length > 0) {
      identifiersToLoad.push(featuresSelector);
    }
    if (pairedMediaCodes?.length > 0) {
      identifiersToLoad.push(pairedMediaSelector);
    }
    if (designersCodes?.length > 0) {
      identifiersToLoad.push(designersSectionSelector);
    }

    await loadBlocks({
      identifiers: identifiersToLoad,
    });
    const blocksContent = await contentGetters.getCmsBlockContent(blocks.value);

    const blocksData = {
      handcrafted: blocksContent[handcraftedSelector],
      faq: blocksContent[faqSelector],
      customisedGlassLighting: blocksContent[customisedGlassLightingSelector],
    };
    if (featuresCodes?.length > 0 && blocksContent[featuresSelector] && blocksContent[featuresSelector].active) {
      blocksData.features = getDataFromCodes(blocksContent[featuresSelector], featuresCodes);
    }
    if (pairedMediaCodes?.length > 0 && blocksContent[pairedMediaSelector] && blocksContent[pairedMediaSelector].active) {
      const pairedMediaData = getDataFromCodes(blocksContent[pairedMediaSelector], pairedMediaCodes);
      blocksData.pairedMedia = managePairedMediaData(pairedMediaData);
    }
    if (designersCodes?.length > 0 && blocksContent[designersSectionSelector] && blocksContent[designersSectionSelector].active) {
      blocksData.designers = getDataFromCodes(blocksContent[designersSectionSelector], designersCodes);
    }

    return blocksData;
  };

  return {
    getPdpBlocks,
  };
};

export default productBlocks;
